/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { FlexCol, FlexRow, Button } from 'sarsaparilla';
import { SearchAutosuggest } from 'shared-ui/search-autosuggest';

export default function MobileSearch({
    isLoading = false,
    submitSearch,
    runSearch,
    heroImage,
}) {
    return (
        <section className="nav-hero-wrap">
            <div className="nav-hero-content-wrap">
                <FlexRow hasGutters={false}>
                    <FlexCol>
                        <div className="nav-hero-search-section-wrap mobile">
                            <div className="nav-search-input-wrapper">
                                <div className="form-item-wrap">
                                    <SearchAutosuggest
                                        size="lg"
                                        placeholder="Search for campsites, tours, and more..."
                                        onRunSearch={runSearch}
                                        defaultEventCategory="Homepage"
                                        id="hero-mobile-search-input"
                                        shouldPopoverFlip={false}
                                    />
                                </div>

                                <Button
                                    className="nav-search-button"
                                    isLoading={isLoading}
                                    onClick={submitSearch}
                                    id="gtm-explore-all-hero-mobile-search"
                                >
                                    SEARCH
                                </Button>
                            </div>
                        </div>
                    </FlexCol>
                </FlexRow>
            </div>

            {heroImage}
        </section>
    );
}

MobileSearch.propTypes = {
    isLoading: PropTypes.bool,
    submitSearch: PropTypes.func,
    runSearch: PropTypes.func,
    heroImage: PropTypes.node,
};
